import React from "react";
import { Image, Shimmer } from "react-shimmer";
import Spacing from "../../../Spacing";
const DoctorProfileLoading = () => {
  return (
    <div style={{ maxWidth: 1024, margin: "0 auto" }}>
      <Spacing md="130" />
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <Shimmer className="rounded" width={"100%"} height={370} />
          </div>
          <div className="col-md-8 g-2 px-3 mt-4 rounded">
            <div className="flex-col g-2">
              <Shimmer className="rounded" width={"100%"} height={20} />
              <Shimmer className="mt-2 rounded" width={40} height={20} />
              <Shimmer className="mt-2 rounded" width={100} height={20} />
              <Shimmer className="mt-2 rounded" width={50} height={20} />
            </div>
            <div className="row d-flex mt-3 g-3 justify-content-between align-items-center">
              <Shimmer className="col-4 mr-2 mt-2 rounded" height={100} />
            </div>

            <div className="d-flex mt-4 gap-3">
              <Shimmer className="rounded-pill" height={45} />
              <Shimmer className="rounded-pill" height={45} />
              <Shimmer className="rounded-pill" height={45} />
              <Shimmer className="rounded-pill" height={45} />
            </div>
            <div className="mt-4 col-12 g-2">
              <Shimmer className="mt-2 rounded" width={"90%"} height={20} />
              <Shimmer className="mt-2 rounded" width={"100%"} height={20} />
              <Shimmer className="mt-2 rounded" width={"100%"} height={20} />
              <Shimmer className="mt-2 rounded" width={"100%"} height={20} />
              <Shimmer className="mt-2 rounded" width={"100%"} height={20} />
              <Shimmer className="mt-2 rounded" width={"100%"} height={20} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorProfileLoading;
